import { SettingsSectionBaseProps } from '../types';
import { AlertInline, AsyncButton, ConditionalWrapper, EditableSectionContainer, EditableSectionRow, Tooltip } from '@uplift/ui-v2';
import { LaunchRounded } from '@mui/icons-material';
import { getProviderStripeConnectProfileLink, ProviderStripeConnectStatus } from '@uplift/api';
import { useGetProviderStripeConnectDetailsQuery } from '@uplift/queries';


const providerStripeOnboardingStatus: Record<ProviderStripeConnectStatus, { label: string; description: string; color: 'info' | 'success' | 'error' | 'warning' }> = {
  [ProviderStripeConnectStatus.notStarted]: {
    label: 'Not started',
    color: 'info',
    description: 'You haven’t begun setting up payouts yet',
  },
  [ProviderStripeConnectStatus.inProgress]: {
    label: 'In progress',
    color: 'info',
    description: 'You’ve started setup but still need to complete all required steps',
  },
  [ProviderStripeConnectStatus.inReview]: {
    label: 'In Review',
    color: 'info',
    description: 'Your information has been submitted and is being reviewed by Stripe. Payouts aren’t enabled yet',
  },
  [ProviderStripeConnectStatus.completed]: {
    label: 'Completed',
    color: 'success',
    description: 'Your payout setup is complete and payouts are enabled',
  },
  [ProviderStripeConnectStatus.needsUpdating]: {
    label: 'Restricted',
    color: 'warning',
    description: 'There’s an issue with your information. Please review and update your payout details',
  },
};

export const PayoutSettingsSection: React.VFC<SettingsSectionBaseProps> = ({ userId }) => {
  const { data } = useGetProviderStripeConnectDetailsQuery(userId);
  const statusDetails = providerStripeOnboardingStatus[data?.status];

  return (
    <EditableSectionContainer
      title="Payouts Account"
      rowDividers
    >
      <EditableSectionRow
        label=""
        rowKey="payout-account"
        actions={(
          <ConditionalWrapper
            condition={!data}
            wrapper={children => (
              <Tooltip title="Payouts account setup is not available right now" placement="bottom">
                <span>
                  {children}
                </span>
              </Tooltip>
            )}
          >
            <Tooltip title="Payments are managed through Stripe Connect" placement="bottom">
              <AsyncButton
                color="secondary"
                endIcon={<LaunchRounded />}
                loaderPlacement="end"
                disabled={!data}
                onClick={async () => {
                  const profileLink = await getProviderStripeConnectProfileLink(userId);

                  window.open(profileLink.data);
                }}
              >
                Edit
              </AsyncButton>
            </Tooltip>
          </ConditionalWrapper>
        )}
        kind="custom"
      >
        <AlertInline
          color={statusDetails?.color}
          title={statusDetails?.label}
        >
          {statusDetails?.description}
        </AlertInline>
      </EditableSectionRow>

    </EditableSectionContainer>
  );
};
